export default __webpack_public_path__ + "static/media/frames_20x30.0c5d80ca.jpg";